import { Mails } from "lucide-react";

const toolsData = {
  "Meetings & Collaboration": [
    {
      name: "Microsoft Teams",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/teams.jpg",
      url: "https://teams.cloud.microsoft/",
    },
    {
      name: "Google Meet",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/gmeet.png",
      url: "https://meet.google.com/landing",
    },
    {
      name: "Zoom",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/zoompng.png",
      url: "https://app.zoom.us/wc",
    },
  ],

  Communication: [
    {
      name: "Mattermost",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/mattermost.png",
      url: "https://lightspeedphotonics-openproject.com/",
    },
    {
      name: "Whatsapp",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/whatsapp.png",
      url: "https://web.whatsapp.com/",
    },
  ],

  "Inventory & Operations": [
    {
      name: "Inventree",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/Inventree.png",
      url: "https://lightspeedphotonics-inventree.com/",
    },
    {
      name: "Microsoft Excel",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/excelpng.webp",
      url: "https://excel.cloud.microsoft/",
    },
  ],

  "Storage & Backup": [
    {
      name: "My Cloud Home",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/mycloudhome.png",
      url: "https://home.mycloud.com/",
    },
    {
      name: "Terramaster",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/terra.png",
      url: "https://home.mycloud.com/",
    },
  ],

  "Payroll & Finance": [
    {
      name: "Razorpay",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/razor.png",
      url: "https://payroll.razorpay.com/",
    },
  ],
  
  "Email Services": [
    {
      name: "Roundcube",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/roundcube.png",
      url: "https://lightspeedphotonics.com/roundcube/",
    },
    {
      name: "Thunderbird",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/thunderbird.png",
      url: "https://www.thunderbird.net/en-US/",
    },
    {
      name: "Outlook",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/outlooksvg.svg",
      url: "https://outlook.office.com/",
    },
    {
      name: "gmail",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/gmail.png",
      url: "https://mail.google.com/",
    },
  ],
  
  "Web Resources": [
    {
      name: "Company Website",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/redlogo.jpeg",
      url: "https://lightspeedphotonics.com/",
    },
  ],

  "Microsoft Services": [
    {
      name: "OneDrive",
      logo: "https://storage.googleapis.com/lsp-webstore/Dashboard/onedrive.png",
      url: "https://lightspeedphotonics-my.sharepoint.com/",
    },
  ],
};

function Tools() {
  return (
    <div className="space-y-6 md:space-y-10">

      {/* PAGE HEADER */}
      <div
        className="rounded-2xl md:rounded-[32px] p-5 md:p-8 text-white"
        style={{
          background:
            "linear-gradient(135deg,#C00000 0%,#8B0000 45%,#111111 100%)",
        }}
      >
        <h1 className="text-2xl md:text-4xl font-bold">
          Business Applications
        </h1>

        <p className="mt-2 md:mt-3 text-sm md:text-base text-white/80">
          Access all company tools, applications and resources from one place.
        </p>
      </div>

      {Object.keys(toolsData).map((category) => (
        <div key={category}>

          {/* CATEGORY HEADER */}
          <div className="mb-4 md:mb-5">
            <h2 className="text-lg md:text-2xl font-bold text-gray-800">
              {category}
            </h2>

            <div className="w-12 md:w-16 h-1 bg-[#C00000] rounded-full mt-2"></div>
          </div>

          {/* TOOLS GRID */}
          <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-3 md:gap-6">

            {toolsData[category].map((tool, index) => (
              <div
                key={index}
                onClick={() => window.open(tool.url, "_blank")}
                className="
                  group
                  bg-white
                  rounded-2xl md:rounded-[24px]
                  p-4 md:p-6
                  border
                  border-gray-100
                  shadow-[0_4px_15px_rgb(0,0,0,0.05)]
                  md:shadow-[0_8px_30px_rgb(0,0,0,0.06)]
                  hover:-translate-y-1 md:hover:-translate-y-2
                  hover:shadow-[0_15px_40px_rgb(0,0,0,0.12)]
                  transition-all
                  duration-300
                  cursor-pointer
                "
              >
                <div className="flex justify-center">

                  <div
                    className="
                      w-14 h-14
                      md:w-20 md:h-20
                      bg-white
                      rounded-xl md:rounded-2xl
                      border
                      border-gray-100
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <img
                      src={tool.logo}
                      alt={tool.name}
                      className="
                        w-8 h-8
                        md:w-12 md:h-12
                        object-contain
                      "
                    />
                  </div>

                </div>

                <div className="text-center mt-3 md:mt-5">

                  <h3 className="font-semibold text-sm md:text-lg text-gray-800 line-clamp-2">
                    {tool.name}
                  </h3>

                  <p className="hidden md:block text-sm text-gray-500 mt-1">
                    Open Application
                  </p>

                </div>

              </div>
            ))}

          </div>

        </div>
      ))}
    </div>
  );
}

export default Tools;

